import { Pipe, PipeTransform } from '@angular/core';
import { round } from 'lodash';

@Pipe({
    name: 'mcGaugeMciStep',
    standalone: true,
})
export class McGaugeMciStepPipe implements PipeTransform {
    transform(
        {
            low,
            high,

        }: { low: number; high: number; scenario: 'weighted' | 'unweighted' },
        ...args: unknown[]
    ): unknown {
        const weightedHigh = high + 100;
        const weightedLow = low + 100;
        

        return round((low + high) * 100);
    }
}
